import React from 'react';
import ATMPageHeader from 'src/components/UI/atoms/ATMPageHeader/ATMPageHeader';
import ATMPagination from 'src/components/UI/atoms/ATMPagination/ATMPagination';
import ATMTable, { columnTypes} from 'src/components/UI/atoms/ATMTable/ATMTable';

type Props = {
  columns: columnTypes[];
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const BatchesStudentListing = ({
  columns,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  return (
      <div className='flex flex-col h-full m-4 gap-4'>
        {/* Page Header */}
        <div>
          <ATMPageHeader
           hideAddButton
            pageTitle='Students'
            searchValue={searchValue}
            onSearchChange={setSearchValue}
          />
        </div>

        {/* Table */}
        <div className='flex-1 overflow-auto flex flex-col'>
            <ATMTable
              columns={columns}
              rows={rows} 
              isLoading={isTableLoading}
            />
        </div>

        <div className='p-4 py-2 flex justify-end'>
            <ATMPagination
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={setPage}
              onRowsPerPageChange={setRowsPerPage}
              rowCount={totalItems}
              rows={rows}
            />
          </div>
      </div>
   
  );
};

export default BatchesStudentListing;